import Typography from "./Typography";
import IconButton from "@mui/material/IconButton";
import { CaretLeft, CaretRight } from "phosphor-react";

type TablePaginationProps = {
    totalItems: number;
    pageSize: number;
    currentPage: number;
    onPageChange: (page: number) => void;
    itemName?: string;
};

const TablePagination = ({
    totalItems,
    pageSize,
    currentPage,
    onPageChange,
    itemName = "items"
}: TablePaginationProps) => {
    const totalPages = Math.ceil(totalItems / pageSize);
    const startItem = currentPage * pageSize;
    const endItem = Math.min(startItem + pageSize, totalItems);
    
    const hasPreviousPage = currentPage > 0;
    const hasNextPage = currentPage < totalPages - 1;

    return (
        <div className="flex items-center justify-between py-2 px-4">
            <Typography variant="body" component="p" className="text-gray-600">
                Showing {startItem + 1}-{endItem} of {totalItems} {itemName}
            </Typography>
            <div className="flex items-center gap-2">
                <IconButton
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={!hasPreviousPage}
                    size="small"
                    aria-label="Previous page"
                >
                    <CaretLeft size={20} />
                </IconButton>
                <div className="flex items-center">
                    <Typography variant="body" component="p">
                        Page {currentPage + 1} of {totalPages}
                    </Typography>
                </div>                
                <IconButton
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={!hasNextPage}
                    size="small"
                    aria-label="Next page"
                >
                    <CaretRight size={20}/>
                </IconButton>
            </div>
        </div>
    );
};

export default TablePagination;